
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { IUserColumnsForDropdown } from '@shared/services/api/legacy/usercolumns-service/usercolumns-model';

@Injectable()
export class UserColumnsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${UserColumnsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/usercolumns';

    public getUserColumnsForDropdown(): Observable<SuccessResponse<IUserColumnsForDropdown> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IUserColumnsForDropdown>>(UserColumnsService.URL + '/dropdown').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

}
